<template>
  <!-- 综合查询 -->
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-permission="'admin:dispatch:yunshuxianlu:add'"
          class="glo_btnItems glo_bgcMainColor"
          @click="addNewRoute()"
          >新建</el-button
        >
        <el-button
          v-permission="'admin:dispatch:yunshuxianlu:del'"
          class="glo_btnItems"
          @click="deleteNewRoute()"
          >删除</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="printBtns">打印</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isselection="true"
      :isShowMoreOperate="false"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
    ></mytable>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageStart"
      :page-size="pageTotal"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageCount"
    >
    </el-pagination>
    <!-- 导出 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
<!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>
    <!-- 线路维护 -->
    <EditTransportRoute ref="refEditTransportRoute" :transportLineId="editRow.id" @success="refresh"/>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import EditTransportRoute from "./EditTransportRoute.vue"
export default {
  mixins: [tableListNew, exportjs,mixin_print],
  components: {
    queryCondition,
    sorttable,
    paging,
    queryBtns,
    mytable,
    EditTransportRoute
  },
  data() {
    return {
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "update", //当前页面的方法
          param: 1, //自定义参数标记
          permission:'admin:dispatch:yunshuxianlu:edit'
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      //需要单独点击的列字段名数组
      fieldList: [],
      Operatewidth: "220px", //操作列的列宽
      //=======================导出相关 结束 =======================

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "admin_transport_line_page_v5", //  页面标识
      reportFiledsNumber: "admin_transport_line_page_v5", // 动态 条件、表头
      activeName: "first",
      selectedId: "",
      selectedNumber: "",
      editRow:{},
    };
  },
  updated() {},
  created() {},
  mounted() {},
  activated() {},

  watch: {},
  methods: {
    refresh(){
      this.getData()
    },
    // 新建
    addNewRoute () {
      this.editRow = {}
      this.$refs.refEditTransportRoute.isShowDialog = true;
    },
    update(row){
      this.editRow = row
      this.$refs.refEditTransportRoute.isShowDialog = true;
    },
    // 删除
    deleteNewRoute (row) {
      if(!row && this.selectTableData.length === 0){
        this.$message.error('请选择需要删除的线路')
        return
      }
      let ids = []
      if(row){
        ids = [row.id]
      }else{
        ids = this.selectTableData.map(item=>item.id)
      }
      this.$API.deleteTransportLines({
        ids
      }).then(res =>{
        this.$message.success('删除成功')
        this.getData()
      }).catch(err=>{
        this.$message.error('删除失败')
      })
    },
  },
};
</script>


<style scoped lang="less">
.container {
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
</style>
